import React, { useState } from 'react';
import Input from '../ui/Input';
import Button from '../ui/Button';

const AddCourse = ({ setCourses }) => {
    const [name, setName] = useState('');
    const [teacher, setTeacher] = useState('');

    const handleAddCourse = (e) => {
        e.preventDefault();
        const newCourse = { id: Date.now(), name, teacher };
        setCourses(prevCourses => [...prevCourses, newCourse]);
        setName('');
        setTeacher('');
    };

    return (
        <form onSubmit={handleAddCourse} className="mb-6">
            <h4 className="text-lg font-semibold mb-2">Add New Course</h4>
            <div className="flex flex-col space-y-2">
                <Input type="text" placeholder="Course Name" value={name} onChange={(e) => setName(e.target.value)} />
                <Input type="text" placeholder="Teacher" value={teacher} onChange={(e) => setTeacher(e.target.value)} />
                <Button type="submit">Add Course</Button>
            </div>
        </form>
    );
};

export default AddCourse;
